<template>
    <div class="progress-custom">
        <div class="row">
            <div class="col-12 text-center">
                <div class="progress-bar-step">
                    <div class="custom-progress-bar" :style="width"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 wizard-progress-text">
                <h3>{{ this.progress_title }}</h3>
                <div class="separator2"></div>
                <p>{{ this.progress_description !== undefined ? this.progress_description : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi feugiat est a purus malesuada pulvinar.' }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['progress', 'progress_title', 'progress_description'],

        computed: {
            width() {
                return 'width: ' + (this.progress / 5) * 100 + '%'
            }
        }
    }
</script>
